import {Component, OnInit} from '@angular/core';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {CommonService} from '@services/common.service';
import {AuthenticationService} from '@services/authentification.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {AlertService} from '@services/alert.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {AccountComponent} from '@components/popup/account/account.component';
import {RetryComponent} from '@module/users/popup/retry/retry.component';
import {PlanSuccessComponent} from '@module/users/popup/plan-success/plan-success.component';
import {PlanErrorComponent} from '@module/users/popup/plan-error/plan-error.component';
import {PlanChangeComponent} from '@module/users/popup/plan-change/plan-change.component';
import {ScheduleSuccessComponent} from '@module/users/popup/schedule-success/schedule-success.component';
import {UserService} from '@services/user.service';
import {PromoPartner} from '@models/promo';
import {ChurnComponent} from '@components/popup/churn/churn.component';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-plan',
    templateUrl: './plan.component.html',
    styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit {
    durationLabels: {[key: string]: string} = {month: 'mensuel', quarter: 'trimestriel', year: 'annuel'};
    aiCreditTooltip = 'Décidez plus vite : notre IA analyse l’annonce et le DPE, met en lumière les opportunités, les alertes et les chiffres à vérifier, puis suggère les ajustements utiles pour fiabiliser votre investissement.';

    user: User = Object.assign({}, EMPTY_USER);
    stripe = Stripe(environment.stripeKey);
    duration = 'month';

    success = '';
    action = '';
    error = '';

    loading = false;
    loading_pm = false;
    loading_retry = false;

    promo = '';
    partner: PromoPartner = null;

    constructor(
        public dialog: MatDialog,
        public commonService: CommonService,
        private route: ActivatedRoute,
        private http: HttpClient,
        private alertService: AlertService,
        public userService: UserService,
        public authenticationService: AuthenticationService,
        public deviceService: DeviceDetectorService,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
        this.success = this.route.snapshot.queryParams.success || '';
        this.action = this.route.snapshot.queryParams.action || '';
        this.error = this.route.snapshot.queryParams.error || '';

        if (this.success !== '') {
            if (this.success === 'Update') {
                this.retryPayment(2);
            } else if (this.success === 'Schedule') {
                const dialogRef = this.dialog.open(ScheduleSuccessComponent, {
                    width: '480px',
                    data: {
                        plan: this.success,
                    }
                });
            } else {
                this.trackingService.subscribe({value: this.success, currency: 'EUR'});
                if (this.authenticationService.currentUser.plan == 'trial' || this.authenticationService.currentUser.plan == 'trial_plus') {
                    this.authenticationService.currentUser.plan = this.success;
                }
                const dialogRef = this.dialog.open(PlanSuccessComponent, {
                    width: '480px',
                    data: {
                        plan: this.success,
                    }
                });
                this.user.subscription.plan = this.success;
            }
            // Traitement fait (popup ouverte, event envoyé) : on retire le paramètre pour qu'un
            // rafraîchissement ne renvoie pas l'event et ne rouvre pas la popup.
            this.commonService.clearQueryParam('success');
        }
        if (this.action === 'changeCb') {
            this.updateCB();
        }
        if (this.action === 'churn') {
            const user = this.authenticationService.currentUser;
            if (user.plan != '' || user.pro_plan != '' || user.subscription?.subscription_id != '') {
                this.openChurn();
            }
        }
        if (this.error !== '') {
            this.trackingService.subscribeFail();
            const dialogRef = this.dialog.open(PlanErrorComponent, {
                width: '480px',
            });
        }

        this.user = this.authenticationService.currentUser;

        // Un seul appel : le backend détermine l'éligibilité (abonnement inclus).
        this.userService.getPromo().subscribe(res => {
            this.promo = res.promo;
            this.partner = res.partner || null;
        }, error => {
        });

        this.route.params.subscribe(p => {
            var params = p;
            if (params.plan != '' && params.plan != undefined) {
                this.duration = 'month';
                this.planSelect(params.plan);
            }
        });

        var that = this;
        window.onscroll = function() {
            if (document.getElementsByClassName('pricing-menu').length > 0) {
                if (document.documentElement.scrollTop > 3000) {
                    (document.getElementsByClassName('pricing-menu') as HTMLCollectionOf<HTMLElement>)[0].style.position = 'inherit';
                } else if (document.documentElement.scrollTop < 2800) {
                    (document.getElementsByClassName('pricing-menu') as HTMLCollectionOf<HTMLElement>)[0].style.position = 'fixed';
                }
            }

            if (document.getElementsByClassName('pricing-full').length > 0) {
                var rect = document.getElementsByClassName('pricing-full')[0].getBoundingClientRect();
                var head = document.getElementsByClassName('princing-head')[0];
                // En mobile, l'en-tête du tableau ne se fige pas au scroll : il recouvre
                // le contenu (header + bandeau + onglets de forfaits déjà fixes)
                if (window.innerWidth < 768) {
                    head.classList.remove('fixed');
                } else if (document.documentElement.scrollTop > (rect.top + 1500)) {
                    head.classList.add('fixed');
                } else if (document.documentElement.scrollTop < (rect.top + 1200)) {
                    head.classList.remove('fixed');
                }
            }
        };
    }

    setDuration(duration) {
        this.duration = duration;
    }

    switchPricing(event: any) {
        var switchPricing = document.getElementsByClassName('switch-pricing') as HTMLCollectionOf<HTMLElement>;
        for (var j = 0; j < switchPricing.length; j++) {
            var target = switchPricing[j].getAttribute('data-target');
            if (target != event.getAttribute('data-target')) {
                console.log('Remove on ' + target);
                switchPricing[j].classList.remove('active');
                var cols = document.getElementsByClassName(target) as HTMLCollectionOf<HTMLElement>;
                for (var k = 0; k < cols.length; k++) {
                    cols[k].style.display = 'none';
                }
            }
        }

        event.classList.add('active');
        var cols = document.getElementsByClassName(event.getAttribute('data-target')) as HTMLCollectionOf<HTMLElement>;
        for (var k = 0; k < cols.length; k++) {
            if (cols[k].classList.contains('col-colspan')) {
                continue;
            }
            cols[k].style.display = 'table-cell';
        }
    }

    planChange(plan) {
        if (this.loading == true) {
            return;
        }

        if (this.user.subscription.plan == plan && this.user.subscription.duration == this.duration) {
            if (this.duration == 'month') {
                this.duration = 'quarter';
            } else if (this.duration == 'quarter') {
                this.duration = 'year';
            } else if (this.duration == 'year') {
                this.duration = 'quarter';
            }
        }

        const dialogRef = this.dialog.open(PlanChangeComponent, {
            width: '550px',
            data: {
                duration: this.duration,
                plan: plan,
                disable: (this.user.subscription.plan == plan ? this.user.subscription.duration : '')
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'updateCB') {
                this.updateCB();
            }
        });
    }

    planSelect(plan) {
        if (this.loading == true) {
            return;
        }

        const dialogRef = this.dialog.open(AccountComponent, {
            width: '480px',
            data: {
                duration: this.duration,
                plan: plan,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.loading = true;
                this.duration = result;
                this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
                    {plan, duration: this.duration}).subscribe(
                    session => {
                        // this.loading = false;
                        this.trackingService.checkout({value: plan});
                        this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                            if (result.error) {
                                alert(result.error.message);
                            }
                        });
                    },
                    (error) => {
                        console.log(error);
                        this.loading = false;
                        this.alertService.error('Erreur');
                    });
            }
        });
    }

    updateCB() {
        if (this.loading_pm == true) {
            return;
        }

        this.loading_pm = true;
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-update-checkout-session`, {}).subscribe(
            session => {
                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                    this.loading_pm = false;
                });
            },
            (error) => {
                console.log(error);
                this.loading_pm = false;
            });
    }

    // Plan partenaire : aucune souscription à résilier (bouton masqué, lien ?action=churn ignoré).
    openChurn(): void {
        if (this.authenticationService.isPartner) {
            return;
        }
        const dialogRef = this.dialog.open(ChurnComponent, {
            width: '550px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'change-plan') {
                window.location.hash = 'plan';
                window.scrollTo({top: document.getElementById('plan')?.offsetTop || 0, behavior: 'smooth'});
            }
        });
    }

    retryPayment(step) {
        if (this.loading_retry == true) {
            return;
        }

        this.loading_retry = true;
        const dialogRef = this.dialog.open(RetryComponent, {
            width: '480px',
            data: {step},
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe(result => {
            this.loading_retry = false;
            if (result !== false && result !== undefined) {
                this.updateCB();
            }
        });
    }
}
